module.exports = __webpack_public_path__ + "static/media/slider-imgyomi2.35720e63.png";